var React = require('react');

function FacebookInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"className":"fill","fillRule":"nonzero","d":"M30 5c0-2.627-2.372-5-5-5H5C2.372 0 0 2.373 0 5v20c0 2.627 2.372 5 5 5h10V18.667h-3.667v-5H15v-1.948c0-3.36 2.523-6.386 5.625-6.386h4.042v5h-4.042c-.442 0-.958.537-.958 1.342v1.992h5v5h-5V30H25c2.628 0 5-2.373 5-5V5z"}));
}

FacebookInline.defaultProps = {"viewBox":"0 0 30 30"};

module.exports = FacebookInline;

FacebookInline.default = FacebookInline;
